export default __webpack_public_path__ + "assets/c6749f.svg";